/**
 * REFACTOR-SPLIT — VAL-INPUT-PERSIST-1D. `OverrideSection` (the generic
 * "Valuation Signer overrides" box, only ever read by the deprecated `/run`
 * path) removed from here; the multiple override now lives on Intake as a
 * purpose-built control (`_IntakeMultipleOverride.tsx`). `humanizeDriver`
 * stays — still imported by `_DriverQuestionnaire.tsx`.
 */
export function humanizeDriver(name: string): string {
  return name.replace(/_/g, ' ').replace(/^./, c => c.toUpperCase())
}
